module.exports = __webpack_public_path__ + "static/media/layer.39400819.svg";